<main class="inside" *ngIf="!isErr; else idNotFound">
    <section class="first_screen">
        <div class="page">
            <form class="search_block">

                <div class="tag_search_bar">
                    <div class="selected_tag_list">
                        <input type="text" placeholder="The Wave, Arizona">
                    </div>
                    <button>GO ></button>
                </div>

            </form>
        </div>
    </section>

    <section class="book_page page">
        <div class="popup">
            <div class="cnt">
                <h1 class="title_page">{{header}}</h1>
                <div class="location">{{subHeader}}</div>
                <app-star-comonent [category]="category"></app-star-comonent>

                <div class="flex_block">

                    <div class="left">
                        <div class="selects">
                            <div class="select">
                                <label>{{'booking-inquiry.accommodation' | translate}}:</label>
                                <div class="styled-select slate">
                                    <select (change)="priceIndex(priceID); totalPrice();selectedDate1()" style="cursor:pointer" [(ngModel)]="priceID">
                          <option disabled selected="selected" [ngValue]="0" >{{'booking-inquiry.please-select' | translate}} </option>
    <option *ngFor="let roomTy of roomTypes; let i = index" [selected]="i == 0" [ngValue]="i">{{roomTy.roomTypeName}}</option>
  </select>
                                </div>
                            </div>
                            <div class="select">
                                <label>{{'booking-inquiry.date' | translate}}:</label>
                                <div class="styled-select slate" *ngIf="priceID == 0; else elseDates1">
                                    <select (change)="selectedDate(dateID); totalPrice();priceIndex(priceID)" style="cursor:pointer" [(ngModel)]="dateID">
                           <option disabled selected="selected" [ngValue]="0" > {{'booking-inquiry.please-select' | translate}} </option>
    <option  *ngFor="let single of SingleRoom;let i=index" [selected]="0" [ngValue]="i">{{single.start | date: 'dd.MM.yyyy'}} - {{single.end | date: 'dd.MM.yyyy'}}</option>
         </select>
                                </div>
                                <ng-template #elseDates1>
                                    <div class="styled-select slate">
                                        <select (change)="selectedDate(dateID); totalPrice();priceIndex(priceID)" style="cursor:pointer" [(ngModel)]="dateID">
                           <option disabled selected="selected" [ngValue]="0" >{{'booking-inquiry.please-select' | translate}} </option>
    <option  *ngFor="let single of DoubleRoom;let i=index" [selected]="0" [ngValue]="i">{{single.start | date: 'dd.MM.yyyy'}} - {{single.end | date: 'dd.MM.yyyy'}}</option>
         </select>
                                    </div>
                                </ng-template>
                            </div>

                            <div class="select" *ngIf="premium">
                                <label>{{'booking-inquiry.flight' | translate}}:</label>
                                <div class="styled-select slate">
                                    <select (change)="selectAirport(airport); totalPrice()" [(ngModel)]="airport" style="cursor:pointer" [disabled]="allowToSelect">
                          <option disabled  [ngValue]="0" > {{'booking-inquiry.please-select' | translate}}</option>
    <option *ngFor="let f of flightFrom; let i = index" [selected]="0"  [ngValue]="i"> <span>{{f.airportName}}</span>&nbsp;&nbsp;&nbsp;&nbsp; <span>{{f.pricee}}</span></option>
  </select>
                                </div>
                            </div>
                            <div class="select" *ngIf="premium">
                                <label>{{'booking-inquiry.board' | translate}}:</label>
                                <div class="styled-select slate">
                                    <select (change)="selectBoardType(boardType); totalPrice()" [(ngModel)]="boardType" style="cursor:pointer" [disabled]="allowToSelect">
                          <option [ngValue]="99999"  selected="99999"> {{firstBoardType}}&nbsp;&nbsp;&nbsp;&nbsp; 0.00€</option>
    <option *ngFor="let b of boardUpgrades; let i = index"   selected="i == 99999" [ngValue]="i">{{b.boardTypeName}} &nbsp;&nbsp;&nbsp;&nbsp;<p>{{b.pricee}}</p></option>
  </select>

                                </div>
                            </div>
                        </div>
                        <div class="result_select">
                            <div *ngIf="lowestPriceIndex == 1">
                                <div class="flex_block">
                                    <span>{{'booking-inquiry.price-pp' | translate}}:</span>
                                    <span> <span *ngIf="!airportChoosen || !dateChoosen">{{'booking-inquiry.from' | translate}}</span> {{priceForSingle}}</span>
                                </div>
                                <div class="flex_block big">
                                    <span>{{'booking-inquiry.price-total' | translate}}:</span>
                                    <span><span *ngIf="!airportChoosen || !dateChoosen">{{'booking-inquiry.from' | translate}}</span> {{priceForSingle1}}</span>
                                </div>
                            </div>
                            <div *ngIf="lowestPriceIndex == 2">
                                <div class="flex_block">
                                    <span>{{'booking-inquiry.price-pp' | translate}}:</span>
                                    <span><span *ngIf="!airportChoosen || !dateChoosen">{{'booking-inquiry.from' | translate}}</span> {{priceForDouble}}</span>
                                </div>
                                <div class="flex_block big">
                                    <span>{{'booking-inquiry.price-total' | translate}}:</span>
                                    <span><span *ngIf="!airportChoosen || !dateChoosen">{{'booking-inquiry.from' | translate}}</span> {{priceForDouble1}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="inputs">
                        <form (ngSubmit)="toggleSubmitAllData()" #submitForm="ngForm">
                            <div class="checkboxes">
                                <div class="label">{{'booking-inquiry.salutation' | translate}}:</div>
                                <div class="checkbox_s">
                                    <input type="radio" name="gender" id="Anrede1" value={{manCode}} [(ngModel)]="submitData.salutationB">
                                    <label for="Anrede1">{{man}}</label>
                                </div>
                                <div class="checkbox_s">
                                    <input type="radio" name="gender" id="Anrede2" value={{womanCode}} [(ngModel)]="submitData.salutationB">
                                    <label for="Anrede2">{{woman}}</label>
                                </div>
                            </div>

                            <div class="flex_block">
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.first-name' | translate}}:</div>
                                    <input type="text" id="firstNameB" name="firstNameB" maxlength="80" [(ngModel)]="submitData.firstNameB" #firstNameB="ngModel">
                                </div>
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.last-name' | translate}}:</div>
                                    <input type="text" id="lastNameB" name="lastNameB" maxlength="80" required [(ngModel)]="submitData.lastNameB" #lastNameB="ngModel">
                                    <div *ngIf="lastNameB.invalid && (lastNameB.dirty || lastNameB.touched)" class="alert alert-danger">

                                        <div *ngIf="lastNameB.errors.required">
                                            {{'booking-inquiry-errors.last-name-required' | translate}}
                                        </div>
                                        <div *ngIf="lastNameB.errors.maxlength">
                                            {{'booking-inquiry-errors.last-name-maxlength' | translate}}
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div class="flex_block">
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.street' | translate}}:</div>
                                    <input type="text" id="street" name="street" maxlength="80" [(ngModel)]="submitData.street" #street="ngModel">
                                </div>
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.street-number' | translate}}:</div>
                                    <input type="text" id="streetNum" name="streetNum" maxlength="10" [(ngModel)]="submitData.streetNum" #streetNum="ngModel">
                                </div>
                            </div>

                            <div class="flex_block">
                                <div class="field_input-flex">
                                    <div class="field_input">
                                        <div class="label">{{'booking-inquiry.country' | translate}}:</div>
                                        <select id="country" name="country" [(ngModel)]="submitData.country" style="cursor:pointer" #country="ngModel">
    <option *ngFor="let count of countries; let i = index" [selected]="i == 56"  [value]="count.code" >{{count.code}}</option>
  </select></div>
                                    <div class="field_input">
                                        <div class="label">{{'booking-inquiry.zip' | translate}}:</div>
                                        <input type="text" class="inputTest1" type="text" id="zip" name="zip" maxlength="10" [(ngModel)]="submitData.zip" #zip="ngModel">

                                    </div>
                                </div>
                                <div class="field_input">
                                    <div class="label"> {{'booking-inquiry.city' | translate}}:</div>
                                    <input type="text" id="city" name="city" maxlength="80" [(ngModel)]="submitData.city" #city="ngModel">

                                </div>


                            </div>

                            <div class="flex_block">
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.phone' | translate}}:</div>
                                    <input type="text" id="phone" name="phone" [required]="!submitData.email" maxlength="20" [(ngModel)]="submitData.phone" #phone="ngModel">
                                    <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="alert alert-danger">

                                        <div *ngIf="phone.errors.required">
                                            {{'booking-inquiry-errors.phone-required' | translate}}
                                        </div>
                                        <div *ngIf="phone.errors.maxlength">
                                            {{'booking-inquiry-errors.phone-maxlength' | translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="field_input">
                                    <div class="label">{{'booking-inquiry.email' | translate}}:</div>
                                    <input type="text" id="email" name="email" [email]="!submitData.phone || email.value != ''" [required]="!submitData.phone" [(ngModel)]="submitData.email" #email="ngModel">
                                    <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">

                                        <div *ngIf="email.errors.required">
                                            {{'booking-inquiry-errors.email-required' | translate}}
                                        </div>
                                        <div *ngIf="email.errors.email">
                                            {{'booking-inquiry-errors.email-email' | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>


                            <div class="tac">
                                <button class="btn o" type="submit" [disabled]="!submitForm.form.valid || countSentInquiry !== 0">{{'booking-inquiry.inquiry-btn' | translate}}</button>
                                <button class="btn g" (click)="back()">{{'detailsPage.back-button' | translate}}</button>
                            </div>
                        </form>
                    </div>


                </div>

            </div>
        </div>
    </section>
    <button type="button" class="btn btn-info btn-lg" data-toggle="modal" id="open-modal-booking" data-target="#confirmModal">Open Modal</button>
    <app-confirm-modal [confirmData]="confirmData"></app-confirm-modal>

</main>

<ng-template #idNotFound>
    <div class="page">

        <h1 class="title_pages">{{err}}</h1>
        <button class="btn btn-warning" (click)="back()">Zurück</button>
    </div>

</ng-template>


// WEBPACK FOOTER //
// ./src/app/details/inquiry/inquiry.component.html